import { Button, Input } from '@treams/treams-ui';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import EmployeesFilters from 'packages/kakapo-ui-application/pages/employees/EmployeesFilters';
import { PageTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';
import Paragraph from 'packages/kakapo-ui-kit/components/common/Paragraph';
import Toggle from 'packages/kakapo-ui-kit/components/forms/controls/Toggle';
import HelpLink from 'packages/kakapo-ui-kit/components/intercom/HelpLink';

const GroupTitle = styled.div`
	text-transform: uppercase;
	letter-spacing: 2px;
	font-size: 12px;
	color: ${(props) => props.theme.colors.lightBlueDark};
`;

function InboxManagerRecurseFilter() {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField('recurse');

	return (
		<Flex alignItems="center" mt={3}>
			<Box flexGrow={1}>
				<Paragraph color="slateBlue">{t('managerInbox.options.recursive')}:</Paragraph>
			</Box>
			<Toggle checked={value} onChange={() => setValue(!value)} name="" value="" unspaced />
		</Flex>
	);
}

function InboxManagerOverdueFilter() {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField('onlyDue');

	return (
		<Flex alignItems="center" mt={3}>
			<Box flexGrow={1}>
				<Paragraph color="slateBlue">{t('managerInbox.options.onlyDue')}:</Paragraph>
			</Box>
			<Toggle checked={value} onChange={() => setValue(!value)} name="" value="" unspaced />
		</Flex>
	);
}

export default function InboxManagerSidebar(props: { onExport: () => void }) {
	const { t } = useTranslation();

	const roles = useViewerRoles();

	const [{ value: startDate }, , { setValue: setStartDate }] = useField('startDate');
	const [{ value: endDate }, , { setValue: setEndDate }] = useField('endDate');

	return (
		<Box width={300}>
			<Flex mt={2}>
				<Box mt={3} mb={2} flexGrow={1} flexShrink={1}>
					<PageTitle>{t('managerInbox.options.title')}</PageTitle>
				</Box>
			</Flex>
			<HorizontalRule />

			{roles.isWorkspaceSuperuser && (
				<Box mt={2}>
					<HelpLink id="help.inbox.manager" />
				</Box>
			)}

			<Box my={4}>
				<Box mb={2}>
					<GroupTitle>{t('dashboard.sidebar.filters.timeframe.title')}</GroupTitle>
				</Box>
				<Flex mb={2}>
					<Box mr={2}>
						<Input.DatePicker value={startDate} onChange={(date) => date && setStartDate(date)} />
					</Box>
					<Input.DatePicker value={endDate} onChange={(date) => date && setEndDate(date)} />
				</Flex>
			</Box>
			<Box my={4}>
				<HorizontalRule />
			</Box>
			<EmployeesFilters status={roles.isWorkspaceSuperuser} />
			{!roles.isWorkspaceSuperuser && <InboxManagerRecurseFilter />}
			<InboxManagerOverdueFilter />
			<Box my={4}>
				<HorizontalRule />
			</Box>
			<GroupTitle>{t('managerInbox.options.export.title')}</GroupTitle>
			<Box mt={2}>
				<Button
					small
					onClick={() => props.onExport()}
					title={t('managerInbox.options.export.button')}
				/>
			</Box>
		</Box>
	);
}
